import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import DelOrdIndexActions, { DelOrdIndexTypes } from '../Stores/DelOrdIndex/Actions';

const getAppStore = state => state.app;

export function* delOrdIndexFetchDelOrdIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(DelOrdIndexActions.delOrdIndexFetchDelOrdIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `delOrd/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        DelOrdIndexActions.delOrdIndexFetchDelOrdIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(DelOrdIndexActions.delOrdIndexFetchDelOrdIndexLoading(false));
  }
}

export function* delOrdIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/delOrdDetail/update/${hdrId}`));
}

export function* delOrdIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/DEL_ORD/${hdrId}/DelOrdHdr`));
}

export function* delOrdIndexResetDelOrdFServ01({ hdrIds }) {
  try {
    yield put(DelOrdIndexActions.delOrdIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `delOrd/fServProcess/RESET_DEL_ORD_F_SERV_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(DelOrdIndexActions.delOrdIndexResetDelOrdFServ01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(DelOrdIndexActions.delOrdIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(DelOrdIndexTypes.DEL_ORD_INDEX_FETCH_DEL_ORD_INDEX, delOrdIndexFetchDelOrdIndex),
  takeLatest(DelOrdIndexTypes.DEL_ORD_INDEX_GO_TO_DOCUMENT, delOrdIndexGoToDocument),
  takeLatest(DelOrdIndexTypes.DEL_ORD_INDEX_GO_TO_AUDIT, delOrdIndexGoToAudit),
  takeLatest(DelOrdIndexTypes.DEL_ORD_INDEX_RESET_DEL_ORD_F_SERV01, delOrdIndexResetDelOrdFServ01)
];
